import GetInvoiceAddressRequestModelBase from '../_generated/modelBases/get-invoice-address-request-model-base';

export default class GetInvoiceAddressRequestModel extends GetInvoiceAddressRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
